export * from './customer-status2statusname.directive';



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/directives/customer-status2statusname/index.ts